import { makeTransducer } from './transducer'
import {
    regions,
    statuses,
    coordinatesToLocation,
    locationToCoordinates,
    createLocationChanged,
    createCoordinatesRequested,
    update } from './model';
import { updateLocation, currentLocation } from './location';

const HOME_REGION = regions.HOME;
const ACCESS_REGION = regions.ACCESS;
const DEPLOYMENTS_REGION = regions.DEPLOYMENTS;
const NOT_FOUND_STATUS = statuses.NOT_FOUND;

const transduce = makeTransducer ({updateLocation, locationToCoordinates, coordinatesToLocation});

const init = ({dispatch}) => {
    const dispatchCurrentLocation = () => {
        const loc = currentLocation();
        dispatch(createLocationChanged(loc));
    };
    window.onpopstate = dispatchCurrentLocation;
    dispatchCurrentLocation();
};

export {
    createCoordinatesRequested,
    HOME_REGION,
    ACCESS_REGION,
    DEPLOYMENTS_REGION,
    NOT_FOUND_STATUS,
    transduce,
    update,
    init
};



// WEBPACK FOOTER //
// ./src/navigation/index.js